import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

export const PrefixWithBullet = styled.span`
  &:not(:first-child):before {
    color: ${colors.foxGrey};
    content: "•";
    display: inline-block;
    padding: 0 4px;
  }
`;
